/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_IssuesInputs */

const en_mk_nav_p_issues = /** @type {(inputs: Mk_Nav_P_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues & projects`)
};

const id_mk_nav_p_issues = /** @type {(inputs: Mk_Nav_P_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue & proyek`)
};

/**
* | output |
* | --- |
* | "Issues & projects" |
*
* @param {Mk_Nav_P_IssuesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_issues = /** @type {((inputs?: Mk_Nav_P_IssuesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_IssuesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_issues(inputs)
	return en_mk_nav_p_issues(inputs)
});